import { useState } from "react";
import { IoMdSend, IoMdMail } from "react-icons/io";
import { FaQuestionCircle, FaHeadset } from "react-icons/fa";

const Support = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const supportEmail = "info@myad360.com";

  const handleEmailClick = () => {
    window.location.href = `mailto:${supportEmail}`;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    const subject = encodeURIComponent(formData.subject);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    );
    window.location.href = `mailto:${supportEmail}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="min-h-screen bg-[#FFFBF5] p-4 sm:p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-6 sm:mb-8">
          <div
            className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full mb-4"
            style={{
              background: "linear-gradient(135deg, #D97706, #EA580C)",
            }}
          >
            <FaHeadset className="text-white text-2xl sm:text-3xl" />
          </div>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1C1410] mb-2">
            Contact Support
          </h1>
          <p className="text-sm sm:text-base text-[#8A7560]">
            We're here to help! Get in touch with our support team.
          </p>
        </div>

        {/* Email Card */}
        <div
          className="bg-white rounded-2xl shadow-[0_10px_30px_-18px_rgba(22,34,27,0.25)] p-4 sm:p-6 md:p-8 mb-6 border-2 border-[#FDE8CD] hover:border-[#F5C77E] transition-all duration-300"
          style={{ borderTop: "4px solid #D97706" }}
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex items-start sm:items-center gap-3 sm:gap-4 flex-1">
              <div className="bg-[#FFF4E5] p-3 sm:p-4 rounded-full flex-shrink-0">
                <IoMdMail className="text-[#D97706] text-2xl sm:text-3xl" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base sm:text-lg font-semibold text-[#1C1410] mb-1">
                  Email Us Directly
                </h3>
                <p className="text-sm sm:text-base text-[#8A7560] mb-2">
                  Send us an email and we'll respond within 24 hours
                </p>
                <button
                  onClick={handleEmailClick}
                  className="text-[#D97706] hover:text-[#EA580C] font-semibold underline decoration-2 underline-offset-4 text-sm sm:text-base break-all"
                >
                  {supportEmail}
                </button>
              </div>
            </div>
            <button
              onClick={handleEmailClick}
              className="bg-gradient-to-r from-[#D97706] to-[#EA580C] hover:from-[#EA580C] hover:to-[#D97706] text-white px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 shadow-md hover:shadow-lg w-full md:w-auto text-sm sm:text-base flex-shrink-0"
            >
              <IoMdSend className="text-lg sm:text-xl" />
              <span>Send Email</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;